function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.89545 15.5046L8.88811 15.506L8.84078 15.5293L8.82745 15.532L8.81811 15.5293L8.77078 15.506C8.76367 15.5038 8.75834 15.5049 8.75478 15.5093L8.75211 15.516L8.74078 15.8013L8.74411 15.8146L8.75078 15.8233L8.82011 15.8726L8.83011 15.8753L8.83811 15.8726L8.90745 15.8233L8.91545 15.8126L8.91811 15.8013L8.90678 15.5166C8.905 15.5095 8.90123 15.5055 8.89545 15.5046ZM9.07211 15.4293L9.06345 15.4306L8.94011 15.4926L8.93345 15.4993L8.93145 15.5066L8.94345 15.7933L8.94678 15.8013L8.95211 15.806L9.08611 15.868C9.09456 15.8702 9.101 15.8684 9.10545 15.8626L9.10811 15.8533L9.08545 15.444C9.08323 15.436 9.07878 15.4311 9.07211 15.4293ZM8.59545 15.4306C8.59251 15.4289 8.589 15.4283 8.58565 15.429C8.58229 15.4298 8.57936 15.4318 8.57745 15.4346L8.57345 15.444L8.55078 15.8533C8.55123 15.8613 8.555 15.8666 8.56211 15.8693L8.57211 15.868L8.70611 15.806L8.71278 15.8006L8.71545 15.7933L8.72678 15.5066L8.72478 15.4986L8.71811 15.492L8.59545 15.4306Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49935 1.33203V5.66536C8.49936 5.91395 8.59196 6.15363 8.7591 6.33764C8.92623 6.52166 9.15591 6.63683 9.40335 6.6607L9.49935 6.66536H13.8327V13.332C13.8328 13.6684 13.7057 13.9924 13.477 14.2391C13.2483 14.4857 12.9348 14.6368 12.5993 14.662L12.4993 14.6654H4.49935C4.16296 14.6655 3.83897 14.5384 3.59232 14.3097C3.34566 14.081 3.19458 13.7675 3.16935 13.432L3.16602 13.332V2.66536C3.16591 2.32898 3.29295 2.00499 3.52168 1.75833C3.75041 1.51168 4.06391 1.36059 4.39935 1.33536L4.49935 1.33203H8.49935ZM9.83268 1.3607C10.0483 1.40646 10.2491 1.50496 10.4173 1.64736L10.4993 1.7227L13.442 4.66536C13.5982 4.82144 13.7132 5.01387 13.7767 5.22536L13.8033 5.33203H9.83268V1.3607Z",
    fill: "#B3C0BD",
    style: {
      fill: "#B3C0BD",
      fill: "color(display-p3 0.7020 0.7529 0.7412)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/defaultFile.b7626a4c02360109e54ba875a77ebcc9.svg";
export { ForwardRef as ReactComponent };